import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import { supabase } from '../services/supabase';

const VEHICLE_LABEL = { scooter: '🛵 Skuter', car: '🚗 Avtomobil', bicycle: '🚲 Velosiped', foot: '🚶 Piyada' };

export default function CouriersPage() {
  const { business } = useAuth();
  const [couriers, setCouriers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAdd, setShowAdd] = useState(false);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({ full_name: '', phone: '', vehicle_type: 'scooter' });
  const [error, setError] = useState('');

  const loadCouriers = useCallback(async () => {
    if (!business?.id) return;
    setLoading(true);
    const { data } = await supabase
      .from('couriers')
      .select('*')
      .eq('business_id', business.id)
      .eq('type', 'cafe_employed')
      .order('created_at', { ascending: false });
    setCouriers(data || []);
    setLoading(false);
  }, [business?.id]);

  useEffect(() => { loadCouriers(); }, [loadCouriers]);

  const handleAdd = async (e) => {
    e.preventDefault();
    if (!form.full_name.trim()) { setError('Ad daxil edin'); return; }
    setSaving(true); setError('');
    try {
      const { error: insErr } = await supabase.from('couriers').insert({
        type: 'cafe_employed',
        business_id: business.id,
        full_name: form.full_name.trim(),
        phone: form.phone.trim() || null,
        vehicle_type: form.vehicle_type,
        status: 'available',
      });
      if (insErr) throw insErr;
      setForm({ full_name: '', phone: '', vehicle_type: 'scooter' });
      setShowAdd(false);
      loadCouriers();
    } catch (err) {
      setError(err.message || 'Xəta baş verdi');
    } finally {
      setSaving(false);
    }
  };

  const toggleActive = async (courier) => {
    await supabase.from('couriers').update({ is_active: !courier.is_active }).eq('id', courier.id);
    loadCouriers();
  };

  const remove = async (courier) => {
    if (!window.confirm(`${courier.full_name} silinsin?`)) return;
    await supabase.from('couriers').delete().eq('id', courier.id);
    loadCouriers();
  };

  return (
    <div style={{ padding: 24, maxWidth: 800 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h1 style={{ fontSize: 22, fontWeight: 800 }}>🚴 Kuryerlərim</h1>
        <button onClick={() => setShowAdd(v => !v)} style={{
          padding: '10px 18px', borderRadius: 10, border: 'none', background: '#6C63FF',
          color: '#fff', fontWeight: 700, cursor: 'pointer',
        }}>
          {showAdd ? '✕ Ləğv et' : '+ Yeni Kuryer'}
        </button>
      </div>

      <p style={{ fontSize: 13, color: '#888', marginBottom: 20 }}>
        Bura yalnız öz işçi kuryerlərin əlavə olunur (Çatdırılma → "Öz kuryerim" rejimi seçilibsə istifadə olunur).
        Cafegoo hovuz kuryerləri burada görünmür — onlar müstəqil mobil rolu ilə işləyir.
      </p>

      {showAdd && (
        <form onSubmit={handleAdd} style={{
          background: '#f8f7ff', border: '2px solid #e0ddff', borderRadius: 14, padding: 18, marginBottom: 20,
        }}>
          <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginBottom: 12 }}>
            <input placeholder="Ad Soyad" value={form.full_name}
              onChange={e => setForm(f => ({ ...f, full_name: e.target.value }))}
              style={{ flex: 1, minWidth: 180, padding: '10px 14px', borderRadius: 8, border: '2px solid #ddd' }} />
            <input placeholder="Telefon" value={form.phone}
              onChange={e => setForm(f => ({ ...f, phone: e.target.value }))}
              style={{ flex: 1, minWidth: 150, padding: '10px 14px', borderRadius: 8, border: '2px solid #ddd' }} />
            <select value={form.vehicle_type} onChange={e => setForm(f => ({ ...f, vehicle_type: e.target.value }))}
              style={{ padding: '10px 14px', borderRadius: 8, border: '2px solid #ddd' }}>
              {Object.entries(VEHICLE_LABEL).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
            </select>
          </div>
          {error && <div style={{ color: '#dc2626', fontSize: 13, marginBottom: 10 }}>{error}</div>}
          <button type="submit" disabled={saving} style={{
            padding: '10px 18px', borderRadius: 8, border: 'none', background: '#6C63FF',
            color: '#fff', fontWeight: 700, cursor: 'pointer', opacity: saving ? 0.6 : 1,
          }}>
            {saving ? 'Əlavə edilir...' : '✓ Əlavə Et'}
          </button>
        </form>
      )}

      {loading ? (
        <p>Yüklənir...</p>
      ) : couriers.length === 0 ? (
        <p style={{ color: '#999' }}>Hələ kuryer əlavə edilməyib.</p>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {couriers.map(c => (
            <div key={c.id} style={{
              display: 'flex', justifyContent: 'space-between', alignItems: 'center',
              padding: '14px 18px', borderRadius: 12, border: '2px solid #eee',
              opacity: c.is_active ? 1 : 0.5,
            }}>
              <div>
                <div style={{ fontWeight: 700 }}>{c.full_name} <span style={{ fontWeight: 400, color: '#888' }}>· {VEHICLE_LABEL[c.vehicle_type] || c.vehicle_type}</span></div>
                <div style={{ fontSize: 13, color: '#888' }}>{c.phone || '—'}</div>
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                <button onClick={() => toggleActive(c)} style={{
                  padding: '6px 12px', borderRadius: 8, border: '2px solid #ddd', background: '#fff',
                  cursor: 'pointer', fontSize: 13,
                }}>
                  {c.is_active ? 'Deaktiv et' : 'Aktiv et'}
                </button>
                <button onClick={() => remove(c)} style={{
                  padding: '6px 12px', borderRadius: 8, border: '2px solid #fecaca', background: '#fef2f2',
                  color: '#dc2626', cursor: 'pointer', fontSize: 13,
                }}>
                  Sil
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
